module.exports = __webpack_public_path__ + "img/1600.0fd8225e.png";